import React, {useEffect, useState} from 'react';
import {AccessibilityInfo, Platform, View} from 'react-native';

import {ProfileActiveAttribute} from '/component/base/ProfileActiveAttribute';
import Text from '/component/base/Text';
import {ProfilePage} from '/constant/TestIDs';
import {ACCOUNT_SETTINGS, SECURITY_SETTINGS} from '/enum/popover.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';

import {styles} from './Settings.style';
import {SettingsProps} from './Settings.types';
import {
  generateGoToOptaviaApp,
  generateGoToOptaviaPayLink,
} from './Settings.util';

export const Settings = ({
  onSettingPress = () => {},
  popoverShow = () => {},
  currentScreen = '',
}: SettingsProps) => {
  const {tt} = useTranslation('screen.profile.settings');

  const [optaviaAppFocused, setOptaviaAppFocused] = React.useState(false);

  const [isScreenReaderOn, setIsScreenReaderOn] = useState(false);
  useEffect(() => {
    AccessibilityInfo.isScreenReaderEnabled().then(setIsScreenReaderOn);

    const sub = AccessibilityInfo.addEventListener(
      'screenReaderChanged',
      setIsScreenReaderOn,
    );

    return () => sub.remove();
  }, []);

  const isWeb = Platform.OS === 'web';

  return (
    <View
      style={styles.base}
      accessibilityRole="list"
      accessibilityLabel="Settings list">
      {/*<ProfileActiveAttribute
        iconName={'profile'}
        label={'Edit profile'}
        onPress={onSettingPress}
      />*/}
      <ProfileActiveAttribute
        testID={ProfilePage.profileSwitchToOptaviaApp}
        iconName={'renew'}
        label={tt('section.setting.optaviapay', () => (
          <Text variant="body" allowFontScaling maxFontSizeMultiplier={2}>
            Switch to
            <Text variant="button" allowFontScaling maxFontSizeMultiplier={2}>
              {' '}
              OPTA
            </Text>
            VIA app
          </Text>
        ))}
        onPress={generateGoToOptaviaApp(
          {popoverShow},
          currentScreen,
          isScreenReaderOn,
        )}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel="Switch to Optavia app"
        onFocus={() => setOptaviaAppFocused(true)}
        onBlur={() => setOptaviaAppFocused(false)}
        style={{base: optaviaAppFocused ? styles.focusedOutline : undefined}}
        isLastElement={false}
        useCompetency={false}
      />
      <ProfileActiveAttribute
        testID={ProfilePage.profileOptaviaPay}
        iconName={'pay'}
        label={tt('section.setting.optaviapay', () => (
          <Text variant="body" allowFontScaling maxFontSizeMultiplier={2}>
            <Text variant="button" allowFontScaling maxFontSizeMultiplier={2}>
              OPTA
            </Text>
            VIA Pay
          </Text>
        ))}
        onPress={generateGoToOptaviaPayLink(
          {popoverShow},
          currentScreen,
          isScreenReaderOn,
        )}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel="Optavia Pay"
        style={{base: undefined}}
        isLastElement={false}
        useCompetency={false}
      />
      <ProfileActiveAttribute
        testID={ProfilePage.profileAccountSettings}
        iconName={'settings'}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel="Account settings"
        label={tt('accountSettings', 'Account settings')}
        onPress={generateCallback({
          func: onSettingPress,
          params: ACCOUNT_SETTINGS,
        })}
        style={{base: undefined}}
        isLastElement={isWeb}
        useCompetency={false}
      />
      {/*<ProfileActiveAttribute
        iconName={'notifications'}
        label={'Notification settings'}
        onPress={() => onSettingPress(NOTIFICATION_SETTINGS)}
      />*/}
      {!isWeb && (
        <ProfileActiveAttribute
          testID={ProfilePage.profileSecuritySettings}
          iconName={'lock'}
          label={tt('securityAndTracking', 'Security & tracking')}
          isLastElement={true}
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel="Security and tracking"
          onPress={generateCallback({
            func: onSettingPress,
            params: SECURITY_SETTINGS,
          })}
          style={{base: undefined}}
          useCompetency={false}
        />
      )}
    </View>
  );
};
